export default "__VITE_ASSET__oIdUTVci__"